<template>
  <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
    <section :class="this.name">
      <div class="bg"></div>

      <div class="content">
        <detail v-if="activeLayer == 'item1'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/item/item1-title.png`" alt=""></h1>

          <div class="detail__tab">
            <button @click="handleClickTo(0)"
                    :class="['detail__tab-button', 'detail__tab-button--item1-1', item1TabIndex == 0 && 'detail__tab-button--active']">무기
            </button>
            <button @click="handleClickTo(3)"
                    :class="['detail__tab-button', 'detail__tab-button--item1-2', item1TabIndex == 1 && 'detail__tab-button--active']">방어구
            </button>
            <button @click="handleClickTo(5)"
                    :class="['detail__tab-button', 'detail__tab-button--item1-3', item1TabIndex == 2 && 'detail__tab-button--active']">세트아이템
            </button>
          </div>

          <slide ref="item1"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.item1.list"
                 :width="documentSize.width"
                 :height="layerData.item1.height"
                 :noPagination="true">
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item1-con-1.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item1-con-2.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item1-con-3.png`" alt="" slot="slide2"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item1-con-4.png`" alt="" slot="slide3"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item1-con-5.png`" alt="" slot="slide4"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item1-con-6.png`" alt="" slot="slide5"/>`,
          </slide>

          <div class="slide-dot-area">
            <button v-if="item1TabIndex == 0"
                    :class="['slide-dot-area__button', layerData.item1.index == 0 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(0)">1번 슬라이드
            </button>
            <button v-if="item1TabIndex == 0"
                    :class="['slide-dot-area__button', layerData.item1.index == 1 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(1)">2번 슬라이드
            </button>
            <button v-if="item1TabIndex == 0"
                    :class="['slide-dot-area__button', layerData.item1.index == 2 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(2)">3번 슬라이드
            </button>
            <button v-if="item1TabIndex == 1"
                    :class="['slide-dot-area__button', layerData.item1.index == 3 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(3)">4번 슬라이드
            </button>
            <button v-if="item1TabIndex == 1"
                    :class="['slide-dot-area__button', layerData.item1.index == 4 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(4)">5번 슬라이드
            </button>
          </div>
        </detail>

        <detail v-if="activeLayer == 'item2'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/item/item2-title.png`" alt=""></h1>

          <div class="detail__tab">
            <button @click="handleClickTo(0)"
                    :class="['detail__tab-button', 'detail__tab-button--item2-1', item2TabIndex == 0 && 'detail__tab-button--active']">무기
            </button>
            <button @click="handleClickTo(1)"
                    :class="['detail__tab-button', 'detail__tab-button--item2-2', item2TabIndex == 1 && 'detail__tab-button--active']">방어구
            </button>
            <button @click="handleClickTo(3)"
                    :class="['detail__tab-button', 'detail__tab-button--item2-3', item2TabIndex == 2 && 'detail__tab-button--active']">세트아이템
            </button>
          </div>

          <slide ref="item2"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.item2.list"
                 :width="documentSize.width"
                 :height="layerData.item2.height"
                 :noPagination="true">

            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item2-con-1.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item2-con-2.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item2-con-3.png`" alt="" slot="slide2"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item2-con-4.png`" alt="" slot="slide3"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/item/item2-con-5.png`" alt="" slot="slide4"/>`,
          </slide>

          <div class="slide-dot-area">
            <button v-if="item2TabIndex == 1"
                    :class="['slide-dot-area__button', layerData.item2.index == 1 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(1)">2번 슬라이드
            </button>

            <button v-if="item2TabIndex == 1"
                    :class="['slide-dot-area__button', layerData.item2.index == 2 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(2)">3번 슬라이드
            </button>

            <button v-if="item2TabIndex == 2"
                    :class="['slide-dot-area__button', layerData.item2.index == 3 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(3)">4번 슬라이드
            </button>

            <button v-if="item2TabIndex == 2"
                    :class="['slide-dot-area__button', layerData.item2.index == 4 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(4)">5번 슬라이드
            </button>
          </div>
        </detail>
      </div>
    </section>
  </transition>
</template>
<script>
  import BasePage from "./mixins/basePage.js";

  export default {
    name: "item",
    mixins: [BasePage],
    data() {
      return {
        name: "item",
        contentData: [
         // {type: "bg", source: this.$staticUrl + "img/bg_4.jpg", objName: "bg"},
          {type:'bg', source:'https://vod.plaync.com/lineage/remaster0320/0320_remaster_bg4.mp4', objName:'bgmovie'},
          {type: "chr", source: this.$staticUrl + "img/obj_4.png", objName: "chr_1", x: 38, y: 115},
          {type: "txt", source: this.$staticUrl + "img/txt_4_tit.png", objName: "obj_tit", x: 1014, y: 383},
          {type: "txt", source: this.$staticUrl + "img/txt_4_stit.png", objName: "obj_stit", x: 994, y: 415},
          {type: "txt", source: this.$staticUrl + "img/txt_4_txt.png", objName: "obj_txt", x: 1021, y: 612},
          {type: "btn", source: this.$staticUrl + "img/btn_4_1.png", objName: "item1", x: 1021, y: 680},
          {type: "btn", source: this.$staticUrl + "img/btn_4_2.png", objName: "item2", x: 1242, y: 680},
        ],
        layerData: {
          item1: {
            list: 6,
            index: 0,
            height: 557,
          },

          item2: {
            list: 5,
            index: 0,
            height: 557,
          },
        },
      };
    },
    computed: {
      item1TabIndex() {
        let tabIndex = 0;
        switch (this.layerData.item1.index) {
          case 0:
          case 1:
          case 2:
            tabIndex = 0;
            break;

          case 3:
          case 4:
            tabIndex = 1;
            break;

          case 5:
            tabIndex = 2;
            break;
        }

        return tabIndex;
      },

      item2TabIndex() {
        let tabIndex = 0;

        switch (this.layerData.item2.index) {
          case 0:
            tabIndex = 0;
            break;

          case 1:
          case 2:
            tabIndex = 1;
            break;

          case 3:
          case 4:
            tabIndex = 2;
            break;
        }

        return tabIndex;
      },
    },
    methods: {
      canvasSet() {
        this.baseCavasSet(this.contentData);
      },
      enter(el, done) {
        this.baseEnter();
        this.canvasSet();
        //this.canvas.start();
        this.baseEnterMotion(el, done, this.contentData);
        this.enterMotion.play();
      },
      leave(el, done) {
        if (this.enterMotion) this.enterMotion.pause();
        this.baseLeaveMotion(el, done);
      },
    },
  };
</script>